import { EtapaConexoesCriacao } from '../model/etapa/etapa-conexao-model';
import { Injectable, inject } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { EtapaBusca } from "../model/etapa/etapa-busca-model";
import { EtapaCriacao } from "../model/etapa/etapa-criacao-model";// supondo que tenha esse modelo
import { EtapaNodeId } from '../model/etapa/etapa-nodeId-model';

@Injectable({
  providedIn: 'root'
})
export class EtapaService {
  private readonly http = inject(HttpClient);

  private urlBase: string = environment.urlBase.concat('/etapa');

  salvarEtapa(etapa: EtapaCriacao): Observable<EtapaCriacao> {
    return this.http.post<EtapaCriacao>(`${this.urlBase}/salvar-etapa`, etapa);
  }
  salvarEtapas(etapas: EtapaCriacao[]): Observable<EtapaNodeId[]> {
    return this.http.post<EtapaNodeId[]>(`${this.urlBase}/salvar-etapas`, etapas);
  }
  salvarConexoesParaEtapa(conexoes: EtapaConexoesCriacao[]): Observable<boolean> {
    return this.http.post<boolean>(`${this.urlBase}/salvar-conexoes`, conexoes);
  }

  buscar(fluxoId: number): Observable<EtapaBusca[]> {
    return this.http.get<EtapaBusca[]>(`${this.urlBase}/buscar/${fluxoId}`);
  }

  buscarTodasEtapasSelect(noLoading?: boolean): Observable<EtapaBusca[]> {
    return this.http.get<EtapaBusca[]>(`${this.urlBase}/buscar-todas`,
      { headers: { 'no-loading': noLoading ? 'true' : 'false' } }
    );
  }

  buscarSelectPorFluxo(fluxoId: number): Observable<{ id: number; titulo: string; descricao?: string }[]> {
    return this.http.get<{ id: number; titulo: string; descricao?: string }[]>(
      `${this.urlBase}/select/${fluxoId}`,
      { headers: { 'no-loading': 'true' } }
    );
  }

  apagarEtapaESuasConexoes(fluxoId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.urlBase}/deletar/${fluxoId}`);
  }

  atualizaPosicaoEtapa(etapaId: number, posicaoX: number, posicaoY: number): Observable<boolean>{
    return this.http.patch<boolean>(`${this.urlBase}/atualiza-posicao/${etapaId}/${posicaoX}/${posicaoY}`, {});
  }

  atualizarEtapasAvancoEPadrao(atualizacoes: { etapaId: number; etapaAvanco?: number; etapaPadrao?: number }[]) {
    return this.http.post<void>(`${this.urlBase}/atualizar-avanco-padrao`, atualizacoes);
  }

}
